import { doRequest } from '@r1-frontend/do-request';
import { requestByConnection, ResponseDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { closePopup, setLoading, setSubmitResult } from '@r1-frontend/bp42/actions';
import BP42Analytics from '@r1-frontend/bp42/analytics/BP42Analytics';
import { BP42CtxDispatch } from '@r1-frontend/bp42/BP42Context';
import BP42Callback from '@r1-frontend/bp42/helpers/BP42Callback';
import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

export type BP42SubmitResult = {
    ok: boolean | undefined,
    message: string,
    status: EResultPopupStatus,
}

const submit = (csrf: string, callbacks: BP42Callback, analytics: BP42Analytics) => async(dispatch: BP42CtxDispatch, getState: () => BP42InitialState) => {
    dispatch(setLoading(true));

    const {
        _uid,
        packageName,
        formData: { name, phone },
        requestDataParams,
        selectedProducts,
    } = getState();

    const resp = await doRequest.apiRequest<ResponseDto>(
        requestByConnection({
            ...requestDataParams,
            product_id: selectedProducts,
            fio: name.value,
            phone: phone.value,
            csrf,
        }),
    );

    let submitResult: BP42SubmitResult;

    if (resp.isSuccess) {
        const { status, message } = resp.payload;
        analytics.successRequest(packageName, message, _uid);

        submitResult = {
            ok: !!status,
            message,
            status: status ? EResultPopupStatus.SUCCESS : EResultPopupStatus.ERROR,
        };
    } else {
        analytics.failureRequest(packageName, _uid);

        submitResult = {
            ok: false,
            message: 'Не удалось отправить заявку.',
            status: EResultPopupStatus.ERROR,
        };
    }

    callbacks.onSubmit(submitResult);

    dispatch(setSubmitResult(submitResult));
    dispatch(closePopup());
    dispatch(setLoading(false));
};

export default submit;
